(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion', '../../../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'), require('../../../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classCallCheck, global.possibleConstructorReturn, global.inherits, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion, global.colors);
    global.ProgressBar = mod.exports;
  }
})(this, function (exports, _classCallCheck2, _possibleConstructorReturn2, _inherits2, _taggedTemplateLiteralLoose2, _react, _reactEmotion, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    height: 4px;\n    background-color: ', ';\n    border-radius: ', ';\n  '], ['\n    height: 4px;\n    background-color: ', ';\n    border-radius: ', ';\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    height: 100%;\n    border-radius: ', ';\n    transition: width 0.2s;\n  '], ['\n    height: 100%;\n    border-radius: ', ';\n    transition: width 0.2s;\n  ']);

  var dragon = _colors2.default.dragon,
      leaf = _colors2.default.leaf,
      gold = _colors2.default.gold,
      silver = _colors2.default.silver;


  var PROGRESS_BAR_BORDER_RADIUS = '10px';

  var getStatusColor = function getStatusColor(status) {
    switch (status) {
      case 'error':
        return dragon;
      case 'warn':
        return gold;
      default:
        return leaf;
    }
  };

  var styles = {
    progressBar: (0, _reactEmotion.css)(_templateObject, silver, PROGRESS_BAR_BORDER_RADIUS),
    progress: (0, _reactEmotion.css)(_templateObject2, PROGRESS_BAR_BORDER_RADIUS)
  };

  var ProgressBar = function (_Component) {
    (0, _inherits3.default)(ProgressBar, _Component);

    function ProgressBar() {
      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, ProgressBar);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
        fakePercentage: 0,
        interval: null
      }, _this.setFakePercentageGrowth = function () {
        var SLOW_THRESHOLD = 60;
        var SLOWER_THRESHOLD = 75;
        var SLOWEST_THRESHOLD = 85;
        var slowerCounter = 0;
        var slowestCounter = 0;

        var addGrowth = function addGrowth(percentage, fixedGrowth) {
          var remainder = 100 - percentage;
          // fixedGrowth is the % amount of the remaining progress bar
          // that we're guaranteed to grow each time
          var fixedAdded = remainder * fixedGrowth;

          if (percentage > SLOWEST_THRESHOLD) {
            fixedAdded /= 4;
            slowestCounter += 1;
          } else if (percentage > SLOWER_THRESHOLD) {
            fixedAdded /= 4;
            slowerCounter += 1;
          } else if (percentage > SLOW_THRESHOLD) {
            fixedAdded /= 3;
          }
          // and a fun random amount
          var randomAdded = (remainder - fixedAdded) * 0.15 * Math.random();

          if (percentage > SLOWEST_THRESHOLD && slowestCounter % 3 === 0 || percentage <= SLOWEST_THRESHOLD && percentage > SLOWER_THRESHOLD && slowerCounter % 2 === 0 || percentage <= SLOWER_THRESHOLD && percentage > SLOW_THRESHOLD || percentage <= SLOW_THRESHOLD) {
            return fixedAdded + randomAdded;
          }

          return 0;
        };

        var growth = setInterval(function () {
          _this.setState({
            fakePercentage: _this.state.fakePercentage + addGrowth(_this.state.fakePercentage, 0.4)
          });

          if (_this.state.fakePercentage >= 97) {
            clearInterval(growth);
          }
        }, 500);

        _this.setState({ interval: growth });
      }, _this.getProgress = function (percentage, status) {
        if (status === 'success' || status === 'warn' || status === 'error') {
          return 100;
        } else if (percentage === undefined || percentage === null) {
          return _this.state.fakePercentage;
        }

        return _this.props.percentage;
      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ProgressBar.prototype.componentDidMount = function componentDidMount() {
      var percentage = this.props.percentage;


      if (percentage === undefined || percentage === null) {
        this.setFakePercentageGrowth();
      }
    };

    ProgressBar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
      var interval = this.state.interval;
      var _props = this.props,
          percentage = _props.percentage,
          status = _props.status;


      if ((percentage === undefined || percentage === null) && prevProps.status !== 'loading' && status === 'loading') {
        if (interval) clearInterval(interval);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ fakePercentage: 0 });
        this.setFakePercentageGrowth();
      }
    };

    ProgressBar.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.state.interval) clearInterval(this.state.interval);
    };

    ProgressBar.prototype.render = function render() {
      var _props2 = this.props,
          percentage = _props2.percentage,
          status = _props2.status;


      return _react2.default.createElement(
        'div',
        { className: styles.progressBar },
        _react2.default.createElement('div', {
          className: styles.progress,
          role: 'progressbar',
          style: {
            width: this.getProgress(percentage, status) + '%',
            backgroundColor: getStatusColor(status)
          },
          'aria-valuenow': percentage,
          'aria-valuemin': '0',
          'aria-valuemax': '100'
        })
      );
    };

    return ProgressBar;
  }(_react.Component);

  exports.default = ProgressBar;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/components/ProgressBar.js
// module id = 2043
// module chunks = 1